/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Relativemonthagomany3Inputs */

const en_relativemonthagomany3 = /** @type {(inputs: Relativemonthagomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} months ago`)
};

const pt_relativemonthagomany3 = /** @type {(inputs: Relativemonthagomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`há ${i?.n} meses`)
};

/**
* | output |
* | --- |
* | "{n} months ago" |
*
* @param {Relativemonthagomany3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativemonthagomany3 = /** @type {((inputs: Relativemonthagomany3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativemonthagomany3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativemonthagomany3(inputs)
	return pt_relativemonthagomany3(inputs)
});
export { relativemonthagomany3 as "relativeMonthAgoMany" }